import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const RouteArrowSvgIcon = () => {
    return (
        <SvgIcon
            sx={{
                width: '21px',
                height: '21px'
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 21 21"
            >
                <mask
                    id="mask0_2385_3233"
                    style={{maskType: "alpha"}}
                    width="21"
                    height="21"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#D9D9D9" d="M0.139 0.984H20.139V20.984H0.139z"></path>
                </mask>
                <g mask="url(#mask0_2385_3233)">
                    <path
                        fill="currentColor"
                        d="M6.805 13.484h1.667v-2.5h2.917v2.084l2.916-2.917-2.916-2.917v2.084h-3.75a.806.806 0 00-.594.24.806.806 0 00-.24.593v3.333zm3.334 5.833c-.209 0-.414-.041-.615-.125a1.694 1.694 0 01-.552-.375l-6.667-6.666a1.695 1.695 0 01-.375-.552 1.594 1.594 0 01-.125-.615c0-.208.042-.413.125-.614.084-.202.209-.386.375-.552L8.972 3.15c.167-.167.35-.292.552-.375.201-.083.406-.125.615-.125.208 0 .413.042.614.125.201.083.386.208.552.375l6.667 6.667c.166.166.291.35.375.552.083.201.125.406.125.614 0 .209-.042.413-.125.615a1.694 1.694 0 01-.375.552l-6.667 6.666c-.166.167-.35.292-.552.375a1.593 1.593 0 01-.614.125zm0-1.666l6.666-6.667-6.666-6.666-6.667 6.666 6.667 6.667z"
                    ></path>
                </g>
            </svg>
        </SvgIcon>
    );
};

export default RouteArrowSvgIcon;